import { defineMessages } from 'react-intl';

export default defineMessages({
  labelNameRows: '{from}-{to} z {count}',
});
